<!-- MOLECULE: AppLogo.vue -->

<script setup lang="ts">
//
// ============================================================================
// IMPORTS
// ============================================================================
//

// Vuetify
import { useDisplay } from "vuetify";

//
// ============================================================================
// COMPOSABLES
// ============================================================================
//

const { smAndDown } = useDisplay();

//
// ============================================================================
// PROPS
// ============================================================================
//

interface Props {
  logoSrc?: string | null;
  logoAlt?: string;
  size?: number;
  title?: string;
  subtitle?: string;
  showText?: boolean;
}

withDefaults(defineProps<Props>(), {
  logoSrc: null,
  logoAlt: "Laboratory Logo",
  size: 36,
  title: "Laboratory",
  subtitle: "Laboratory Information System",
  showText: true,
});
</script>

<template>
  <div class="d-flex align-center ga-2">
    <v-img
      v-if="logoSrc"
      :src="logoSrc"
      :lazy-src="logoSrc"
      :alt="logoAlt"
      :width="size"
      height="auto"
    >
      <template #placeholder>
        <div class="d-flex align-center justify-center fill-height">
          <v-progress-circular indeterminate color="primary" />
        </div>
      </template>

      <template #error>
        <div class="d-flex align-center justify-center fill-height">
          <v-icon icon="mdi-image-broken" :size="size" color="grey" />
        </div>
      </template>
    </v-img>

    <div>
      <h1 class="font-weight-medium" :class="smAndDown ? 'text-body-2' : 'text-h6'">
        {{ title }}
      </h1>
      <p class="text-caption text-medium-emphasis" :class="smAndDown ? '' : 'mt-n1'">
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>
